import { P2PConfig, P2PDeal, P2PPost } from "../models/p2p";
import { formatNumber } from "./formatNumber";

export interface Notification {
  post: P2PPost;
  deal?: P2PDeal;
  message: string;
}

const getP2PNotifications = (
  configs: P2PConfig[],
  posts: P2PPost[],
  address: string
): Notification[] => {
  const myPosts = posts.filter(
    (p) => p.dealer === address || !!p.deals.find((d) => d.customer === address)
  );

  const notifications: Notification[] = [];
  myPosts.forEach((p) => {
    const config = configs.find(
      (c) => c.deal_token.address === p.deal_token.address
    );
    if (p.dealer === address) {
      if (p.state === "pend_dealer_deposit") {
        return notifications.push({
          post: p,
          message: `Please deposit ${formatNumber(
            p.amount / 10 ** (config?.decimals || 6)
          )} ${config?.name} to your post`,
        });
      }
      p.deals.forEach((d) => {
        if (d.state === "pend_dealer_bank_transfer") {
          return notifications.push({
            post: p,
            deal: d,
            message: `Trader has deposited ${formatNumber(
              d.amount / 10 ** (config?.decimals || 6)
            )} ${config?.name}`,
          });
        } else if (d.state === "pend_dealer_sign_off") {
          return notifications.push({
            post: p,
            deal: d,
            message: `Trader has transfered ${formatNumber(
              (((d.settle_price || 0) / 10 ** (config?.decimals || 6)) *
                (d.amount || 0)) /
                10 ** (config?.decimals || 6)
            )} ${p.settle_currency.currency} to you`,
          });
        } else if (d.state === "dispute") {
          return notifications.push({
            post: p,
            deal: d,
            message: `Your deal (ID: ${d.deal_id}) is in dispute. Please reach out to moderator to resolve it as soon as possible.`,
          });
        }
      });
    } else {
      const d = p.deals.find((d) => d.customer === address);
      if (d?.state === "pend_customer_deposit") {
        return notifications.push({
          post: p,
          deal: d,
          message: `Please deposit ${formatNumber(
            d.amount / 10 ** (config?.decimals || 6)
          )} ${config?.name} to your deal`,
        });
      } else if (d?.state === "pend_customer_bank_transfer") {
        return notifications.push({
          post: p,
          deal: d,
          message: `Dealer has deposited ${formatNumber(
            d.amount / 10 ** (config?.decimals || 6)
          )} ${config?.name}`,
        });
      } else if (d?.state === "pend_customer_sign_off") {
        return notifications.push({
          post: p,
          deal: d,
          message: `Dealer has transfered ${formatNumber(
            (((d.settle_price || 0) / 10 ** (config?.decimals || 6)) *
              (d.amount || 0)) /
              10 ** (config?.decimals || 6)
          )} ${p.settle_currency.currency} to you`,
        });
      } else if (d?.state === "dispute") {
        return notifications.push({
          post: p,
          deal: d,
          message: `Your deal (ID: ${d.deal_id}) is in dispute. Please reach out to moderator to resolve it as soon as possible.`,
        });
      }
    }
  });
  return notifications;
};

export default getP2PNotifications;
